import type { FC, HTMLAttributes } from "react";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { mergeClasses } from "@huub-web/utils";

export type EnergyLabelValue =
  | "A++++"
  | "A+++"
  | "A++"
  | "A+"
  | "A"
  | "B"
  | "C"
  | "D"
  | "E"
  | "F"
  | "G";

import {
  containerSizeStyle,
  containerStyle,
  textStyle,
} from "./EnergyLabel.css";

export type EnergyLabelProps = HTMLAttributes<HTMLDivElement> &
  RecipeVariants<typeof containerSizeStyle> & {
    label: EnergyLabelValue;
  };

export const EnergyLabel: FC<EnergyLabelProps> = ({
  label,
  size = "m",
  className,
  justifySelf,
  ...props
}) => {
  const validLabel = label.toUpperCase().replace(/\+/g, "Plus");

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((label as any) === "Niet beschikbaar") {
    return null;
  }

  return (
    <div
      className={mergeClasses(
        containerStyle?.[validLabel as keyof typeof containerStyle] ||
          containerStyle.G,
        containerSizeStyle({ size, justifySelf }),
        className,
      )}
      {...props}
    >
      <span
        className={mergeClasses(
          textStyle({
            color: ["D", "E"].includes(label) ? "dark" : "light",
            size,
          }),
        )}
      >
        {label}
      </span>
    </div>
  );
};
